import React from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { Broker } from '@/types'
import { fontSizes } from '@/styles'
import { isEmptyOrNull } from '@/utils'
import BlurredText from '@/components/blurred-text'
import CdnImage from '@/components/cdn-image'

const LogoContainer = styled.div`
  position: relative;
  display: flex;
  height: 45px;
  width: 80px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`

const BrokerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  gap: 16px;
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    z-index: 1;
  }
`
const ConactInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Subtitle = styled.span`
  font-size: ${fontSizes.small};
`

const BrokerInfoBlurred = ({ broker }: { broker: Broker }) => {
  const { t } = useTranslation()
  const logo = broker?.logo?.location || broker?.logo

  if (isEmptyOrNull(broker)) return null

  return (
    <BrokerContainer>
      {!!logo && (
        <LogoContainer>
          <CdnImage
            src={logo as string}
            sizes="80px"
            layout="fill"
            placeholder="blur"
            objectFit="contain"
            alt={`${broker?.name || 'Broker'} Logo`}
          />
        </LogoContainer>
      )}
      <ConactInfoColumn>
        <Subtitle>
          {t('listing:b.listing.view.brokerage.text', 'Brokerage')}
        </Subtitle>
        <BlurredText variant={{ weight: 'medium' }}>
          **** **** **** ****
        </BlurredText>
      </ConactInfoColumn>
    </BrokerContainer>
  )
}

export default BrokerInfoBlurred
